import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses, offerIncludes, productName } from '../data/content';
import { CtaButton } from './CtaButton';
import { ProductCollage } from './ProductCollage';
import { BonusFan } from './BonusFan';
import { PrintCutShare } from './PrintCutShare';
import { SunRays } from './decor/SunRays';
export function FinalOffer() {
  return <section id="offer" aria-labelledby="offer-title" className="relative overflow-hidden bg-cream-deep" data-id="element-97" data-mp="1qebglo8zifwo">
      <SunRays className="pointer-events-none absolute -right-40 -top-40 w-[560px] text-gold/20" data-id="element-98" data-mp="1lg07jfqik9fi" />
      <div className="relative mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-99" data-mp="204wcv516r8cf">
        <h2 id="offer-title" className="mx-auto max-w-3xl text-balance text-center font-display text-[40px] leading-[1.04] text-navy sm:text-[58px]" data-id="element-100" data-mp="1v5bccq6darxl">
          Sichere dir noch heute
          <span className="mt-2 block text-[26px] leading-tight text-coral sm:text-[44px]" data-id="element-101" data-mp="292q78afe3rwy">{productName}</span>
        </h2>

        <div className="mt-14 space-y-6" data-id="element-102" data-mp="1pp1fkkcdyia">
          <ProductCollage data-id="element-103" data-mp="1qql2dffbtbm" />
          <BonusFan data-id="element-104" data-mp="1rjjmr48bcio" />
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl overflow-hidden rounded-3xl bg-white shadow-sheet ring-2 ring-coral/25 md:grid-cols-[1.2fr_1fr]" data-id="element-105" data-mp="6o0b9van090i">
          <div className="p-7 sm:p-9" data-id="element-106" data-mp="bmbn2bkhstld">
            <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-coral-deep" data-id="element-107" data-mp="gmfznqia546b">Dein digitales Paket enthält:</p>
            <ul className="mt-5 space-y-3" data-id="element-108" data-mp="kn9t0zehrb6l">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 font-bold text-navy" data-id="element-109" data-mp="pmckfh1jtiw3">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-leaf-deep" strokeWidth={3} aria-hidden="true" data-id="element-110" data-mp="udkxqo601oej" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-8 text-xs font-extrabold uppercase tracking-[0.14em] text-gold-deep" data-id="element-111" data-mp="14ctvls3zjn66">+ 5 exklusive Bonusmaterialien:</p>
            <ul className="mt-4 space-y-3" data-id="element-112" data-mp="18eotsnqmdkfq">
              {bonuses.map(b => <li key={b.number} className="flex items-start gap-3 font-bold text-navy" data-id="element-113" data-mp="35fl1fkintpql">
                  <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-114" data-mp="30g83o4q92y98" />
                  {b.name}
                </li>)}
            </ul>
          </div>

          <div className="flex min-w-0 flex-col items-center justify-center bg-cream px-5 py-8 text-center sm:p-9" data-id="element-115" data-mp="39fldiyiadouh">
            <p className="text-sm font-extrabold uppercase tracking-[0.12em] text-ink-mute" data-id="element-116" data-mp="3o3yds7oeptus">
              Gesamtwert <span className="line-through decoration-coral decoration-2" data-id="element-117" data-mp="3j54x66dtpmqe">97 €</span>
            </p>
            <p className="mt-2 text-sm font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-118" data-mp="z0dw8bjo841">Nur heute</p>
            <p className="whitespace-nowrap font-display text-[80px] leading-[0.95] text-coral sm:text-[96px]" aria-label="22,90 €" data-id="element-119" data-mp="3t4m1okhc9uks">
              22<span className="align-top text-[40px] leading-none sm:text-[48px]" data-id="element-120" data-mp="22thq43m9xruz">,90 €</span>
            </p>
            <p className="mt-3 max-w-[18rem] text-balance text-sm font-semibold leading-relaxed text-ink-soft" data-id="element-121" data-mp="1om4nd7c81shf">
              Einmalzahlung · Kein Abo · Sofortiger digitaler Zugang
              <span className="block" data-id="element-122" data-mp="1spkk03oajsu4">Kostenlose Updates – ein Leben lang.</span>
            </p>
            <CtaButton checkout block className="mt-6" data-id="element-123" data-mp="1eu8q1yhym6e9">
              Ja, ich möchte das Paket!
            </CtaButton>
            <p className="mt-5 text-xs font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-124" data-mp="14y5gi7ks35ha">Über 200 Bibelverse • 20+ Designs</p>
            <div className="mt-3" data-id="element-125" data-mp="19xi8t7uf54r9">
              <PrintCutShare data-id="element-126" data-mp="19yjo5oigwdes" />
            </div>
            <p className="mt-3 font-display text-xl italic text-leaf-deep" data-id="element-127" data-mp="vy0giihwz9d5">Fang noch heute an, das Evangelium zu säen.</p>
          </div>
        </div>
      </div>
    </section>;
}